(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('SMSController', sms_controller);

  sms_controller.$inject = ['$scope', '$http', '$stateParams', '$state', 'NotificationFactory', 'CompanyService', 'FoundationApi', 'SMSService', 'TriggerService', 'NotificationService'];

  function sms_controller ($scope, $http, $stateParams, $state, NotificationFactory, CompanyService, FoundationApi, SMSService, TriggerService, NotificationService) {
    var vm = this;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    	vm.metadata = {};
    	vm.baseUrl = baseUrl;
    	vm.openModal = openModal;

    function reload () {
      CompanyService.find({
        id: $stateParams.id
      }, function (data) {
        vm.company = data;
        if (!vm.number) {
          vm.sms = {};
          vm.sms.company_id = vm.sms.id;
        }
        if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
          for (var i in vm.company.metadata) {
            if (typeof vm.company.metadata[i]['value'] === 'string') {
              vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value']);
            } else {
              vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value'];
            }
          }
        }

        parseTriggers();
      });
    }
    reload();
    function openModal () {
      openModal(false);
    }
    function openModal (clearForm) {
      if (clearForm) {
        vm.sms = {};
      }
      FoundationApi.publish('addSMSModal', 'open');
    };

    vm.editar = function (sms) {
      vm.sms = sms;
      FoundationApi.publish('addSMSModal', 'open');
    }
    vm.changeHandler = function (sms) {
      switch (vm.sms.gateway) {
        case 'classe_a':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\ClasseA';
          break;
        case 'zenvia':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\ZEnvia';
          break;
        case 'tyntec':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\Tyntec';
          break;
        case 'egoi':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\EGoi';
          break;
        case 'hotmobile':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\HotMobile';
          break;
        case 'smsviaweb':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\SMSViaWeb';
          break;
        case 'smspg':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\PG';
          break;
        case 'calixta':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\Calixta';
          break;
        case 'movile':
          vm.sms.integradora = 'App\\Library\\SMS\\Integradora\\Movile';
          break;
        default:
          vm.sms.integradora = null;
          break;
      }
    }
    vm.parseGatewayName = function (gateway) {
      switch (gateway) {
        case 'classe_a':
              return 'Classe A';
        case 'zenvia':
        			return 'ZEnvia';
        case 'tyntec':
              return 'Tyntec';
        case 'egoi':
          return 'Egoi';      
        case 'hotmobile':
          return 'Hot Mobile';
        case 'smsviaweb':
          return 'SMS Via Web';
        case 'smspg':
          return 'PG';
        case 'calixta':
          return 'Calixta';
        case 'movile':
          return 'movile';
        default:
        	return $scope.labels.ignoreDept;
      }
    }
    vm.parseGatewayMeta = function (sms) {
      if (typeof sms.extra_data == 'string') {
        sms.extra_data = {};
      }

      switch (sms.gateway) {
        case 'classe_a':
          return sms.extra_data.admin_email + ' - ' + sms.extra_data.admin_hash;
        case 'zenvia':
          return sms.extra_data.admin_email;
        case 'tyntec':
          return 'Tyntec';
        case 'hotmobile':
          return sms.extra_data.admin_email;
        case 'smsviaweb':
          return sms.extra_data.admin_email;
        case 'smspg':
          return 'SMS PG';
        case 'calixta':
          return 'Calixta';
        case 'movile':
          return 'Movile';
        		default:
        			return $scope.labels.ignoreDept;
        	}
    }
    vm.saveSMS = function (sms) {
      vm.sms = sms;

      // Valida dados necessários caso a integradora seja a egoi
      if (vm.sms.gateway === 'egoi') {
        if (!vm.sms.extra_data.apiKey || !vm.sms.extra_data.from) {
          NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!');
          return;
        }
      }

      // Valida dados necessários caso a integradora seja a Tyntec
      if (vm.sms.gateway == 'tyntec') {
        if (!vm.sms.extra_data || !vm.sms.extra_data.apiKey || !vm.sms.extra_data.from) {
          NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!');
          return;
        }
      }

      if (vm.sms.id == undefined) {
        if (vm.sms.default_sector_id == null) {
          FoundationApi.publish('notifications', { title: $scope.labels.error, content: $scope.labels.requiredSector, autoclose: '3000', color: 'alert' });
          return;
        }
            	SMSService.create({},
            		vm.sms,
            		function (data) {
	                	reload();
	                	FoundationApi.publish('notifications', { title: $scope.labels.saved, content: $scope.labels.dataCreated, autoclose: '3000', color: 'success' });
	                	FoundationApi.publish('addSMSModal', 'close');
	            	},
	            	function (error) {
		                var message = $scope.labels.errorRequest;
		                if (error) {
		                    if (error.data) {
                if (error.data.message) { message = error.data.message; }
              }
		                }
            FoundationApi.publish('addSMSModal', 'close');
	                 	FoundationApi.publish('notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
	            });
      } else {
        if (vm.sms.default_sector_id == 0) {
          FoundationApi.publish('notifications', { title: $scope.labels.error, content: $scope.labels.requiredSector, autoclose: '3000', color: 'alert' });
          return;
        }
        SMSService.update({
	                id: vm.sms.id
	            }, vm.sms,
	            function (data) {
          FoundationApi.publish('addSMSModal', 'close');
	                FoundationApi.publish('notifications', { title: $scope.labels.saved, content: $scope.labels.dataUpdated, autoclose: '3000', color: 'success' });
	            }, function (error) {
	                var message = $scope.labels.errorRequest;
	                if (error) {
	                    if (error.data) {
              if (error.data.message) { message = error.data.message; }
            }
	                }
          FoundationApi.publish('addSMSModal', 'close');
	                FoundationApi.publish('notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
	            });
      }
      //
    }

    function parseTriggers () {
      vm.company.sms.forEach(
        function (sms, indexSms, collection) {
          if (sms.triggers.length > 0) {
            sms.triggers.forEach(
              function (trigger, indexTrigger, collectionTrigger) {
                if (trigger.trigger_type == 'offline_operators_notification') {
                  vm.company.sms[indexSms].trigger_offline = {};
                  vm.company.sms[indexSms].trigger_offline.params = {};
                  if (!trigger.hasOwnProperty('params') || trigger.params == null) {
                    vm.company.sms[indexSms].trigger_offline.params = { active: true };
                  } else {
                    trigger.params = JSON.parse(trigger.params);
                    if (!trigger.params.hasOwnProperty('active')) {
                      vm.company.sms[indexSms].trigger_offline.params.active = true;
                    } else {
                      vm.company.sms[indexSms].trigger_offline.params = trigger.params;
                    }
                  }

                  var jsonActions = JSON.parse(vm.company.sms[indexSms].triggers[indexTrigger].actions);
                  vm.company.sms[indexSms].trigger_offline.text = jsonActions[0].params.text;
                }
              });
          } else {
            vm.company.sms[indexSms].trigger_offline = { text: '', params: { active: true } };
          }
        });
    }

    vm.saveOfflineMessage = function (sms) {
      TriggerService.saveOthers({
        op: 'save-triggers-others', type: 'sms', id: sms.id
      }, {
        offline_operators_notification: sms.trigger_offline
      }, function (resp) {
        successHandler(resp, $scope.labels.triggersSaved);
      }, function (error) {
        errorHandler(error, $scope.labels.errorSaveTriggers);
      });
    }

    vm.setPGReturn = function () {
      SMSService
        .setPGReturn({ channel: vm.sms })
        .$promise
        .then(function (data) {
          notifSet.addNotification({ title: $scope.labels.success, content: $scope.labels.urlUpdated, autoclose: '3000', color: 'success' });
        })
        .catch(function (error) {
          notifSet.addNotification({ title: $scope.labels.error, content: $scope.labels.errorUpdateUrl, autoclose: '3000', color: 'alert' });
        });
    }

    function successHandler (data, override_message) {
      var message = $scope.labels.dataSaved;
      if (override_message) {
        message = override_message;
      } else {
        if (data && data.data && data.data.message) {
          message = data.data.message;
        }
      }
      notifSet.addNotification({ title: $scope.labels.success, content: message, autoclose: '3000', color: 'success' });
    }

    function errorHandler (data, override_message) {
      var message = 'Erro. Tente novamente!';
      if (override_message) {
        message = override_message;
      } else if (data && data.data && data.data.message) {
        message = data.data.message;
      }
      notifSet.addNotification({ title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }
  }
})();
